import React, { Component } from "react";
import { Modal, Header, Input, Button } from "semantic-ui-react";
import "../ScanShippingContainerModal/ScanShippingContainerModal.css";
import SortBoxEndpoints from "../../lib/sortbox/SortBoxEndpoints";
import SharedFunctions from "../../utils/SharedFunctions";
import { SCAN_SHIPPING_LABEL_MODAL } from "../../utils/constants/componentConstants";

class ScanShippingLabelModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scanValue: "",
      showError: false,
      errorMessage: "",
    };
  }

  componentDidMount() {
    SharedFunctions.LogPopupShownEvent(SCAN_SHIPPING_LABEL_MODAL);
  }

  //Set focus on input
  handleRef = (c) => {
    this.inputRef = c;
  };
  componentDidUpdate() {
    if (this.inputRef && this.inputRef.focus) {
      this.inputRef.focus();
    }
  }

  handleInputChange = (e) => {
    this.setState({
      scanValue: (e.target.value || "").toUpperCase(),
    });
  };

  onInputKeyPress(e) {
    if (e.key === "Enter") {
      this.submitShippingContainer();
    }
  }

  submitShippingContainer = () => {
    let barcode = this.state.scanValue;

    if (barcode && barcode.length > 2 && barcode.substring(0, 2) === "TB") {
      let packageNumber = this.props.packageNumber;
      let operatorID = this.props.operatorID;
      let workstationID = this.props.workstationID;
      let companyID = this.props.companyID;

      SortBoxEndpoints.shippingContainerScan(
        packageNumber,
        barcode,
        operatorID,
        companyID,
        workstationID
      )
        .then((result) => {
          if (!result.error) {
            this.setState(
              {
                showError: false,
                errorMessage: "",
                scanValue: "",
              },
              this.props.onClose()
            );
          } else {
            this.setState({
              showError: true,
              errorMessage: result.message,
              scanValue: "",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      this.setState({
        showError: true,
        errorMessage: "Felaktigt backnummer",
        scanValue: "",
      });
    }
  };

  render() {
    const { open } = this.props;

    let errorMessage = (
      <div className="ui message">
        <div className="header">{this.state.errorMessage}</div>
      </div>
    );

    return (
      <div className={"ModalWrapper"} onClick={() => this.inputRef.focus()}>
        <Modal
          open={open}
          className="shippingContainerModal"
          size="small"
          closeOnEscape={false}
          closeOnDimmerClick={false}
        >
          <Header>
            <Header.Content>
              <h2>Scanna transportback</h2>
            </Header.Content>
          </Header>
          <Modal.Content>
            <div style={{ verticalAlign: "top" }}>
              <div style={{ display: "inline-block", paddingLeft: "10px" }}>
                <Input
                  ref={this.handleRef}
                  placeholder="transportback.."
                  value={this.state.scanValue}
                  onChange={this.handleInputChange}
                  onKeyPress={(e) => this.onInputKeyPress(e)}
                />
              </div>
              {this.state.showError && errorMessage}
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button secondary onClick={() => this.props.onClose()}>
              Avbryt
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default ScanShippingLabelModal;
